import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
export default {
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: ''
    },
    htmlValue: {
      type: String,
      required: false,
      default: ''
    },
    highlightKey: {
      type: String,
      required: false,
      default: ''
    },
    /**  目标元素 */
    target: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    line: {
      type: [String, Number],
      default: '1'
    }
  },
  data: function data() {
    return {
      visible: true,
      isShow: true
    };
  },
  watch: {
    value: function value() {
      this.getItem();
    },
    isShow: function isShow(val) {
      if (!val) {
        this.removeDom();
      }
    }
  },
  computed: {
    formatedValue: function formatedValue() {
      var escapeHtml = function escapeHtml(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      };
      var escapeRegExp = function escapeRegExp(s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      };
      var raw = this.value == null ? '' : this.value;
      var text = String(raw);
      var escaped = escapeHtml(text);
      var key = this.highlightKey || '';
      if (!key) {
        return "<div>".concat(escaped, "</div>");
      }
      var chars = Array.from(key).filter(function (c) {
        return c && c.trim() !== '';
      }).map(function (c) {
        return escapeRegExp(c);
      });
      if (chars.length === 0) {
        return "<div>".concat(escaped, "</div>");
      }
      var pattern = new RegExp('(' + chars.join('|') + ')', 'g');
      var highlighted = escaped.replace(pattern, '<span class="text-primary">$1</span>');
      return "<div>".concat(highlighted, "</div>");
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getItem();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeDom();
  },
  methods: {
    removeDom: function removeDom() {
      if (this.$refs.maxBox) {
        var dom = this.$refs.maxBox.getAttribute('aria-describedby');
        if (dom) {
          if (document.querySelector('#' + dom)) {
            document.querySelector('#' + dom).remove();
          }
        }
      }
    },
    getItem: function getItem() {
      var _this = this;
      this.$nextTick(function () {
        if (!_this.$refs.truncate) return;
        var maxBox = '';
        if (_this.target) {
          maxBox = document.querySelector(_this.target) || _this.$refs.maxBox;
        } else {
          maxBox = _this.$refs.maxBox;
        }
        var truncate = _this.$refs.truncate.offsetWidth / (_this.line - 0);
        truncate = _this.line > 1 ? truncate += 4 : truncate;
        if (maxBox.offsetWidth < truncate) {
          _this.isShow = true;
        } else {
          _this.isShow = false;
        }
      });
    }
  }
};